import { NOT_SET, TrackingParameter } from '@sunrise/tracking'

import { TealiumTrackingIds } from '../tracking/tealiumTrackingIds.enum'
import { BookmarkListBodyType } from '../utils/trackingUtils.enum'

export function buildTealiumOpenBookmarkListData(type: BookmarkListBodyType): TrackingParameter {
    return {
        mslayer_element_body_type: type,
        mslayer_element_company_name: NOT_SET,
        mslayer_element_count: NOT_SET,
        mslayer_element_data_id: TealiumTrackingIds.BOOKMARK_OPEN_LIST_CLICK,
        mslayer_element_detail_start_date: NOT_SET,
        mslayer_element_id: NOT_SET,
        mslayer_element_position: NOT_SET,
        mslayer_element_text: 'öffnen',
        mslayer_element_type_text: 'Merkliste',
        mslayer_element_variant: 'default',
    }
}

export function buildPartnerExposeErrorData(exposeeId: string): TrackingParameter {
    return {
        mslayer_element_body_type: NOT_SET,
        mslayer_element_company_name: NOT_SET,
        mslayer_element_count: NOT_SET,
        mslayer_element_data_id: TealiumTrackingIds.DETAIL_PARTNER_IFRAME_TIMEOUT,
        mslayer_element_detail_start_date: NOT_SET,
        mslayer_element_position: NOT_SET,
        mslayer_element_text: 'Immobilien_Fehlerseite',
        mslayer_element_type_text: 'Fremdinventar_iFrame',
        mslayer_element_variant: NOT_SET,
        mslayer_element_id: exposeeId,
    }
}
